(() => {
  let sharedData;
  const cityNames = { Baku:'Bakı', Istanbul:'İstanbul', Dubai:'Dubay', Rome:'Roma', Moscow:'Moskva', 'Saint Petersburg':'Sankt-Peterburq', Vienna:'Vyana', Warsaw:'Varşava', Kyiv:'Kiyev', Kiev:'Kiyev', Munich:'Münhen', Prague:'Praqa', Athens:'Afina', Budapest:'Budapeşt', Geneva:'Cenevrə', Cairo:'Qahirə', Seoul:'Seul', Beijing:'Pekin', Tokyo:'Tokio', 'New York':'Nyu-York', 'Los Angeles':'Los-Anceles', 'Abu Dhabi':'Abu Dabi', Sharjah:'Şarja', Riyadh:'Ər-Riyad', Jeddah:'Ciddə', Copenhagen:'Kopenhagen', Ganja:'Gəncə', Nakhchivan:'Naxçıvan', Fuzuli:'Füzuli', Zangilan:'Zəngilan', Lankaran:'Lənkəran', Gabala:'Qəbələ' };
  const metro = { IST:'Istanbul', SAW:'Istanbul', GYD:'Baku', DXB:'Dubai', DWC:'Dubai', LHR:'London', LGW:'London', LCY:'London', LTN:'London', STN:'London', CDG:'Paris', ORY:'Paris', JFK:'New York', EWR:'New York', LGA:'New York', SVO:'Moscow', DME:'Moscow', VKO:'Moscow', HND:'Tokyo', NRT:'Tokyo', FCO:'Rome', CIA:'Rome' };
  const extraAliases = { GYD:'baki baku баку', IST:'istanbul istambul стамбул', SAW:'istanbul sabiha gokcen стамбул', DXB:'dubai dubay дубай', DWC:'dubai dubay', TBS:'tbilisi tiflis тбилиси', LHR:'london londres лондон', LTN:'london', LGW:'london', STN:'london', CDG:'paris parij paris şarl de qoll', ORY:'paris', FCO:'roma rome rim', JFK:'nyc new york nyu york', SVO:'moskva moscow', DME:'moskva moscow', VKO:'moskva moscow' };
  const fold = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i').replace(/ə/g,'e').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
  const getData = (url) => {
    if (!sharedData) sharedData = fetch(url, { credentials:'omit', cache:'force-cache' }).then((response) => {
      if (!response.ok) throw new Error('Airport list unavailable');
      return response.json();
    }).then((data) => {
      if (data.version !== 1 || !Array.isArray(data.airports)) throw new Error('Invalid airport list');
      let regions;
      try { regions = new Intl.DisplayNames(['az'], { type:'region' }); } catch {}
      const countries = {};
      for (const [code, name] of Object.entries(data.countries)) countries[code] = regions?.of(code) || name;
      return data.airports.map(([code, municipality, name, countryCode, priority]) => {
        const originalCity = metro[code] || municipality;
        const city = cityNames[originalCity] || originalCity;
        const country = countries[countryCode] || countryCode;
        return { code, city, name, country, priority, value:`${city} — ${name} (${code})`, cityKey:fold(`${city} ${originalCity} ${municipality}`), searchKey:fold(`${code} ${city} ${originalCity} ${municipality} ${name} ${country} ${data.countries[countryCode] || ''} ${extraAliases[code] || ''}`) };
      });
    }).catch((error) => { sharedData = undefined; throw error; });
    return sharedData;
  };
  function init(root) {
    if (!root || root.dataset.airportsInitialized) return;
    root.dataset.airportsInitialized = 'true';
    root.querySelectorAll('[data-fx-airport-picker]').forEach((picker) => {
      const input = picker.querySelector('input');
      const panel = picker.querySelector('[data-fx-airport-panel]');
      const list = picker.querySelector('[data-fx-airport-options]');
      const status = picker.querySelector('[data-fx-airport-status]');
      const more = picker.querySelector('[data-fx-airport-more]');
      let dataset, matches = [], active = -1, limit = 12, timer, request = 0;
      const fitPanel = () => {
        if (panel.hidden || window.innerWidth > 650) return;
        const viewport = window.visualViewport;
        const available = () => (viewport?.height || window.innerHeight) + (viewport?.offsetTop || 0) - input.getBoundingClientRect().bottom - 12;
        if (available() < 140) input.scrollIntoView({block:'start',behavior:'instant'});
        panel.style.maxHeight = `${Math.max(120,Math.min(360,available()))}px`;
      };
      const close = () => {
        clearTimeout(timer);
        request++;
        panel.hidden = true;
        input.setAttribute('aria-expanded','false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
      };
      const open = () => {
        panel.hidden = false;
        input.setAttribute('aria-expanded','true');
        fitPanel();
        root.querySelectorAll('[data-fx-airport-panel]').forEach((other) => {
          if (other !== panel) { other.hidden = true; other.closest('[data-fx-airport-picker]').querySelector('input').setAttribute('aria-expanded','false'); }
        });
      };
      const setActive = (index) => {
        const options = list.querySelectorAll('[role="option"]');
        if (!options.length) return;
        active = Math.max(0, Math.min(index, options.length - 1));
        options.forEach((node,i) => node.setAttribute('aria-selected', String(i===active)));
        input.setAttribute('aria-activedescendant', options[active].id);
        options[active].scrollIntoView({ block:'nearest' });
      };
      const choose = (index) => {
        const airport = matches[index];
        if (!airport) return;
        input.value = airport.value;
        input.dataset.airportCode = airport.code;
        input.dataset.airportValue = airport.value;
        input.dataset.airportCountry = airport.country;
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
        close();
        if (document.activeElement !== input) input.dataset.skipAirportOpen = 'true';
        input.focus({preventScroll:true});
      };
      const draw = () => {
        list.replaceChildren();
        matches.slice(0,limit).forEach((airport,index) => {
          const item = document.createElement('div');
          item.id = `${input.id}-option-${index}`;
          item.className = 'fx-airport-option';
          item.setAttribute('role','option');
          item.setAttribute('aria-selected','false');
          item.dataset.airportIndex = String(index);
          const title = document.createElement('span');
          title.className = 'fx-airport-option-title';
          title.textContent = airport.city;
          const detail = document.createElement('span');
          detail.className = 'fx-airport-option-detail';
          detail.textContent = `${airport.name} · ${airport.country}`;
          const code = document.createElement('span');
          code.className = 'fx-airport-option-code';
          code.textContent = airport.code;
          item.append(title,detail,code);
          list.append(item);
        });
        status.textContent = matches.length ? `${matches.length} ${root.dataset.airportCount}` : root.dataset.airportEmpty;
        more.hidden = matches.length <= limit;
        active = -1;
        input.removeAttribute('aria-activedescendant');
        fitPanel();
      };
      const search = () => {
        const currentCode = input.dataset.airportValue === input.value ? input.dataset.airportCode : null;
        const raw = currentCode || input.value;
        const term = fold(raw);
        const tokens = term.split(' ').filter(Boolean);
        const ranked = [];
        for (const airport of dataset) {
          if (tokens.length && !tokens.every((token) => airport.searchKey.includes(token))) continue;
          const code = fold(airport.code);
          const score = (code === term ? 1000 : code.startsWith(term) && term ? 500 : airport.cityKey.startsWith(term) && term ? 250 : 0) + airport.priority;
          ranked.push({airport,score});
        }
        ranked.sort((a,b) => b.score-a.score || a.airport.city.localeCompare(b.airport.city,'az'));
        matches = ranked.map((item) => item.airport);
        draw();
      };
      const run = async () => {
        const thisRequest = ++request;
        open();
        limit = 12;
        if (dataset) { search(); return; }
        status.textContent = root.dataset.airportLoading;
        list.replaceChildren();
        more.hidden = true;
        input.setAttribute('aria-busy','true');
        try {
          dataset = await getData(root.dataset.airportsUrl);
          if (thisRequest === request && document.activeElement === input) search();
        } catch {
          if (thisRequest === request) status.textContent = root.dataset.airportFailed;
        } finally { input.removeAttribute('aria-busy'); }
      };
      input.addEventListener('focus', () => {
        if (input.dataset.skipAirportOpen) { delete input.dataset.skipAirportOpen; return; }
        run();
      });
      input.addEventListener('input', () => {
        if (input.dataset.airportValue !== input.value) { delete input.dataset.airportCode; delete input.dataset.airportValue; delete input.dataset.airportCountry; }
        clearTimeout(timer);
        timer = setTimeout(run,120);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key==='ArrowDown' || event.key==='ArrowUp') {
          event.preventDefault();
          if (panel.hidden) run();
          setActive(active + (event.key==='ArrowDown' ? 1 : -1));
        } else if (event.key==='Enter' && !panel.hidden && active>=0) { event.preventDefault(); choose(active); }
        else if (event.key==='Escape' && !panel.hidden) { event.preventDefault(); event.stopPropagation(); close(); }
        else if (event.key==='Tab') close();
      });
      panel.addEventListener('mousedown', (event) => event.preventDefault());
      panel.addEventListener('click', (event) => {
        const item = event.target.closest('[data-airport-index]');
        if (item) { clearTimeout(timer); choose(Number(item.dataset.airportIndex)); }
      });
      more.addEventListener('click', () => { limit += 12; draw(); });
      picker.addEventListener('focusout', (event) => { if (!picker.contains(event.relatedTarget)) close(); });
      document.addEventListener('pointerdown', (event) => { if (!picker.contains(event.target)) close(); });
      window.visualViewport?.addEventListener('resize',fitPanel,{passive:true});
    });
  }
  document.querySelectorAll('[data-fx-site]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-fx-site]')));
})();
